import { makeVar, useReactiveVar } from '@apollo/client'
import { GallerySettings, initialGallerySettings } from '../components/gallerySettings'

export const gallerySettingsVar = makeVar<GallerySettings>(initialGallerySettings)

export default function useGallerySettings() {
  const settings = useReactiveVar<GallerySettings>(gallerySettingsVar)

  return {
    saveGallerySettings: (gallerySettings: GallerySettings) => {
      gallerySettingsVar({ ...gallerySettings })
    },
    settings
  }
}
